import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AlertService } from '../../../../../core/services/alert.service';
import { AuthModalService } from '../../../../../shared/components/modals/auth-modal/auth-model.service';
import { VerificationCodeComponent } from '../../../../../shared/modules/inputs/components/verification-code/verification-code.component';
import { AuthService } from '../../services/auth.service';
import { VerifyEmailService } from '../../services/verify-email.service';

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrl: './verify-email.component.scss',
    imports: [
        CommonModule,
        RouterModule,
        VerificationCodeComponent,
        InlineSVGModule,
    ],
    encapsulation: ViewEncapsulation.None
})
export class VerifyEmailComponent {
  constructor(
    private userService: AuthService,
    private alertService: AlertService,
    private router: Router,
    public verifyEmailService: VerifyEmailService,
    private authModalService: AuthModalService,
  ) {}

  async submit(code: string) {
    const res = await this.userService.verifyEmail({
      email: this.verifyEmailService.email,
      code,
    });
    this.alertService.suucess(res.message);

    if (this.authModalService.isInModal) {
      this.authModalService.goLogin();
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  async resendCode() {
    const res = await this.userService.verifyEmailResendCode({
      email: this.verifyEmailService.email,
    });

    this.alertService.suucess(res.message);
  }
}
